import React, {useEffect, useRef, useState} from 'react'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import Form from 'components/Form';
import * as Yup from 'yup';
import useId from 'hooks/useId';
import {connect} from 'react-redux'
import VS from "constants/ValidationShema";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import PartsTable from "components/PartsTable";
import getObjectValue from "libs/getObjectValue";
import {PurchasingGroupTemplateFieldType} from "../constants/PurchasingGroupTemplateFieldType";

function PurchasingGroupTemplateAggregatedFieldsPopup(
    {
        formikProps,
        fieldId,
        onClose,
        formSubmit,
    }) {

    const sendType = useRef('');
    const [working, setWorking] = useState(true);
    const [fieldsList, setFieldsList] = useState([]);
    const formId = useId();
    const curSelected = getObjectValue(fieldId, formikProps.values, [])

    const handleSubmit = (type) => {
        sendType.current = type;
        formSubmit[formId]();
    }

    useEffect(() => {
        const fieldsListTmp = getObjectValue("fields", formikProps.values, [])
            .map((x, i) => ({identity: x.uniqueId, name: x.name, order: i+1, type: x.type}))
            .filter(x => x.type === PurchasingGroupTemplateFieldType.NUMBER);
        setFieldsList(fieldsListTmp);
        setWorking(false)
        // eslint-disable-next-line
    }, []);


    const onSubmit = ({uniqueIds}) => {
        const aggregatedFields = Object.keys(uniqueIds).filter(x => uniqueIds[x] === true);
        formikProps.setFieldValue(fieldId, aggregatedFields, true);
        onClose();

    }

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), onClose, 'outlined', working));
        buttons.push(createButton(Tr('save'), () => handleSubmit('save'), undefined, working));
        return buttons;
    }


    return (
        <Dialog
            open={true}
            maxWidth='md'
            dialogActions={<MultiButton buttons={getButtons()}/>}
        >
            {
                !!fieldsList &&
                <Form
                    initialValues={{
                        uniqueIds: fieldsList.reduce((prev, cur) => {
                            prev[cur.identity] = curSelected.includes(cur.identity);
                            return prev;
                        }, {}),
                    }}
                    validationSchema={Yup.object().shape({
                        uniqueIds: VS.lazy((memberIds) => {
                            const index = Object.keys(memberIds).findIndex(r => memberIds[r] === true);
                            return index === -1 ? VS.immediatelyError(Tr("choose_at_least_one")) : VS.any();
                        })
                    })}
                    onSubmit={onSubmit}
                    id={formId}
                >
                    {(formikProps) => (
                        <PartsTable
                            formikProps={formikProps}
                            label={Tr('choose_aggregated_fields')}
                            id="uniqueIds"
                            elementList={fieldsList}
                            orderLabel="field_number"
                        />
                    )}
                </Form>
            }
        </Dialog>
    )
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(PurchasingGroupTemplateAggregatedFieldsPopup);